import gql from 'graphql-tag';

export const addressFragment = gql`
  fragment AddressFields on GQL_Address {
    state
    street
    street_number
    unit_number
    postal_code
    formatted
    city
  }
`;

export const settingsDefaultFragment = gql`
  fragment SettingsDefaultFragment on GQL_ProductPolicySettingConfigMinMax {
    max
    min
    default {
      __typename
      ... on DefaultValueSetting {
        preset_value_number
        preset_value_string
        enabled
        fee_calculation_method
        fee_type
        fixed
      }
    }
  }
`;
